<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    class="animate-spin"
  >
    <path
      d="M48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24ZM6 24C6 33.9411 14.0589 42 24 42C33.9411 42 42 33.9411 42 24C42 14.0589 33.9411 6 24 6C14.0589 6 6 14.0589 6 24Z"
      fill="#3A3A3C"
    />
    <g filter="url(#filter0_i_56299_14927)">
      <path
        d="M24 0C27.1517 3.75839e-08 30.2726 0.620779 33.1844 1.82689C36.0962 3.033 38.742 4.80083 40.9706 7.02944C43.1992 9.25805 44.967 11.9038 46.1731 14.8156C47.3792 17.7274 48 20.8483 48 24H42C42 21.6362 41.5344 19.2956 40.6298 17.1117C39.7252 14.9278 38.3994 12.9435 36.7279 11.2721C35.0565 9.60062 33.0722 8.27475 30.8883 7.37017C28.7044 6.46558 26.3638 6 24 6V0Z"
        fill="url(#paint0_linear_56299_14927)"
      />
    </g>
    <defs>
      <filter
        id="filter0_i_56299_14927"
        x="24"
        y="0"
        width="24"
        height="28"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite
          in2="hardAlpha"
          operator="arithmetic"
          k2="-1"
          k3="1"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.33 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_56299_14927"
        />
      </filter>
      <linearGradient
        id="paint0_linear_56299_14927"
        x1="37.5"
        y1="40.5"
        x2="12.5"
        y2="7"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.495087"
          stop-color="currentColor"
        />
      </linearGradient>
    </defs>
  </svg>
</template>